import axios from "axios";
import Cookies from "js-cookie";
import { FIRMFLOWURL } from "./url";
export const saveSubscriptionNotes = (sub_id, notesAndMentions) => {
    console.log(notesAndMentions);

    return new Promise(async (resolve) => {
        try {
            const token = Cookies.get("Bearer");
            const response = await axios.put(
                `${FIRMFLOWURL}api/ClientSubscription/${sub_id}/notes`,
                notesAndMentions,
                {
                    headers: { Authorization: token },
                }
            );
            resolve({ ...response, success: true });
        } catch (err) {
            console.log(err);
            if (err.message.includes(401)) {
                Cookies.remove("Bearer");
                window.location.replace("/");
                return;
            }
            resolve({ success: false, message: err.response.data.message });
        }
    });
};

export const saveSubscriptionTemporaryNotes = (sub_id, notesAndMentions) => {
    return new Promise(async (resolve) => {
        try {
            const token = Cookies.get("Bearer");
            const response = await axios.put(
                `${FIRMFLOWURL}api/ClientSubscription/${sub_id}/temporary-notes`,
                {
                    temporaryNotes: notesAndMentions.notes,
                    mentionedEmployeesIds: notesAndMentions.mentionedEmployeesIds,
                },
                {
                    headers: { Authorization: token },
                }
            );
            resolve({ ...response, success: true });
        } catch (err) {
            console.log(err);
            if (err.message.includes(401)) {
                Cookies.remove("Bearer");
                window.location.replace("/");
                return;
            }
            resolve({ success: false, message: err.response.data.message });
        }
    });
};
